export default class OfferDetailResponse {
    constructor (json) {
        this.successful = json.responseCode === 'SUCCESS'
        this._offerDetails = json.offerDetails
    }

    success () {
        return this.successful
    }

    getProperty (name) {
        return this._offerDetails[name]
    }

    getOffer () {
        return this._offerDetails
    }
}

// "responseCode": "SUCCESS",
//     "offerDetails": {
//     "id": 340998,
//         "rank": "",
//         "rewardAmount": 0.05,
//         "rewardType": "CPG",
//         "description": "BellStores Basket Offer  ",
//         "longDescription": "Earn $0.05/gal for every $25 spent",
//         "termsAndConditions": "Earn 5¢/gal for every $25 you spend at participating BellStores locations. Must swipe your Bell Buddy Rewards card, enter your Alt ID, or scan your app barcode at check out to update purchase balance. Spend is cumulative and can be accrued over multiple visits. Offer excludes fuel, alcohol, cigarettes and tobacco including vaping products, lottery, money orders, gift and prepaid cards. Offer may be extended or discontinued at any time.",
//         "startDate": "2019-01-14 00:00:00",
//         "endDate": "",
//         "imageName": "app-offer-bellstores-basket",
//         "requirements": {},
//     "categories": []
// }



// WEBPACK FOOTER //
// ./src/models/responses/OfferDetailResponse.js